import React from "react";
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  Paper,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import contactConfig from "../../Configurations/addressConfig.json";
const SuccessIcon = () => (
  <Box sx={{ fontSize: 80, textAlign: "center" }}>✅</Box>
);

const MedicineOrderSuccessScreen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDialog, setOpenDialog] = React.useState(false);
  const { orderId, totalAmount, paymentMethod, deliveryAddress } =
    location.state || {};

  const handleGoHome = () => {
    navigate("/services");

  // window.location.reload();
  };

  const handleViewOrders = () => {
    navigate("/my-orders");

  // window.location.reload();
  };


  const handleContactSupport = () => {
    setOpenDialog(true);
  };
  
  // const handleCall = () => {
  //   const phone = contactConfig.support.call;
  //   window.open(`tel:+${phone}`);
  //   setOpenDialog(false);
  // };
  
  const handleEmail = () => {
    const email = contactConfig.support.email;
    window.open(`mailto:${email}`);
    setOpenDialog(false);
  };
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#F9FAFB", pb: 15 }}>
      <Container maxWidth="md" sx={{ py: 2, px: 2 }}>
        {/* Success Icon */}
        <Box sx={{ textAlign: "center", mt: 5, mb: 3 }}>
          <SuccessIcon />
        </Box>

        {/* Success Message */}
        <Typography
          sx={{
            fontSize: 28,
            fontWeight: 700,
            color: "#111827",
            textAlign: "center",
            mb: 1,
          }}
        >
          Order Placed Successfully!
        </Typography>
        <Typography
          sx={{
            fontSize: 16,
            color: "#6B7280",
            textAlign: "center",
            mb: 4,
            px: 2.5,
          }}
        >
          Your order has been confirmed and will be delivered soon
        </Typography>

        {/* Order Details Card */}
        <Card
          elevation={3}
          sx={{
            borderRadius: 4,
            mb: 2,
          }}
        >
          <CardContent sx={{ p: 2.5 }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 700,
                color: "#111827",
                mb: 2,
              }}
            >
              Order Details
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#6B7280" }}>
                Order ID:
              </Typography>
              <Typography
                sx={{ fontSize: 14, fontWeight: 600, color: "#111827" }}
              >
                {orderId || "N/A"}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#6B7280" }}>
                Total Amount:
              </Typography>
              <Typography
                sx={{ fontSize: 18, fontWeight: 700, color: "#006D77" }}
              >
                ₹{totalAmount?.toFixed(2) || "0.00"}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1.5,
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#6B7280" }}>
                Payment Method:
              </Typography>
              <Typography
                sx={{ fontSize: 14, fontWeight: 600, color: "#111827" }}
              >
                {paymentMethod === "online"
                  ? "Online Payment"
                  : "Cash on Delivery"}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 14, color: "#6B7280" }}>
                Payment Status:
              </Typography>
              <Chip
                label={paymentMethod === "online" ? "Paid" : "Pending"}
                sx={{
                  bgcolor:
                    paymentMethod === "online" ? "#D1FAE5" : "#FEF3C7",
                  color:
                    paymentMethod === "online" ? "#059669" : "#D97706",
                  fontWeight: 700,
                  fontSize: 12,
                  height: 28,pointerEvents: "none",
                }}
              />
            </Box>
          </CardContent>
        </Card>

        {/* Delivery Address Card */}
        <Paper
          elevation={0}
          sx={{
            bgcolor: "#F0F9FA",
            borderRadius: 4,
            p: 2.5,
            mb: 2,
            borderLeft: "4px solid #006D77",
          }}
        >
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 700,
              color: "#111827",
              mb: 2,
            }}
          >
            Delivery Address
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#111827",
                mb: 0.5,
              }}
            >
              {deliveryAddress?.full_name}
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 700,
                color: "#111827",
                mb: 0.5,
              }}
            >
              {deliveryAddress?.community_name}
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                color: "#374151",
                mb: 0.25,
              }}
            >
              Block No:{deliveryAddress?.address_line1}
              {deliveryAddress?.address_line2
                ? `, ${deliveryAddress.address_line2}`
                : ""}
          
            </Typography>
          
            <Typography
              sx={{
                fontSize: 14,
                color: "#006D77",
                mt: 1,
                fontWeight: 600,
              }}
            >
              📞 {deliveryAddress?.phone}
            </Typography>
          </Box>
        </Paper>

        {/* What's Next Section */}
        <Card
          elevation={3}
          sx={{
            borderRadius: 4,
            mb: 2,
          }}
        >
          <CardContent sx={{ p: 2.5 }}>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 700,
                color: "#111827",
                mb: 2,
              }}
            >
              What's Next?
            </Typography>

            {[
              {
                number: "1",
                title: "Order Confirmation",
                text: "You'll receive a confirmation email shortly",
              },
              {
                number: "2",
                title: "Order Processing",
                text: "Our pharmacy will verify and pack your order",
              },
              {
                number: "3",
                title: "Out for Delivery",
                text: "You'll get tracking details once shipped",
              },
              {
                number: "4",
                title: "Delivered",
                text: "Expected delivery within a day",
              },
            ].map((step, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  mb: index < 3 ? 2.5 : 0,
                }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: 2,
                    bgcolor: "#006D77",
                    color: "#fff",
                    fontSize: 16,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: 2,
                    flexShrink: 0,
                  }}
                >
                  {step.number}
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: "#111827",
                      mb: 0.5,
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: "#6B7280",
                      lineHeight: 1.43,
                    }}
                  >
                    {step.text}
                  </Typography>
                </Box>
              </Box>
            ))}
          </CardContent>
        </Card>

        {/* Help Section */}
        <Paper
          elevation={0}
          sx={{
            bgcolor: "#FEF3C7",
            borderRadius: 4,
            p: 2.5,
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 700,
              color: "#111827",
              mb: 1,
            }}
          >
            Need Help?
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              color: "#6B7280",
              mb: 2,
            }}
          >
            Contact our support team for any queries about your order
          </Typography>
          <Button
            variant="contained"
            onClick={handleContactSupport}
            sx={{
              bgcolor: "#fff",
              color: "#D97706",
              fontWeight: 700,
              fontSize: 14,
              py: 1.5,
              px: 3,
              borderRadius: 2,
              textTransform: "none",
              "&:hover": {
                bgcolor: "#FFFBEB",
              },
            }}
          >
            Contact Support
          </Button>
        </Paper>
      </Container>

      {/* Action Buttons */}
      <Paper
        elevation={28}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          justifyContent: "center", 
          p: 2,
          display: "flex",
          gap: 1.5,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          onClick={handleViewOrders}
          sx={{
            bgcolor: "#F3F4F6",
            color: "#374151",
            fontWeight: 700,width:"15%",
            fontSize: 16,
            py: 2,
            borderRadius: 3,
            textTransform: "none",
            "&:hover": {
              bgcolor: "#E5E7EB",
            },
          }}
        >
          View My Orders
        </Button>

        <Button
          variant="contained"
          fullWidth
          onClick={handleGoHome}
          sx={{
            bgcolor: "#006D77",
            color: "#fff",
            fontWeight: 700,width:"15%",
            fontSize: 16,
            py: 2,
            borderRadius: 3,
            textTransform: "none",
            "&:hover": {
              background: "linear-gradient(90deg, #004F55 0%, #006D77 100%)",
            },
          }}
        >
          Back to Home
        </Button>
      </Paper>

      {/* Contact Support Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        PaperProps={{
          sx: {
            borderRadius: 4,
            minWidth: 300,
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: "#111827" }}>
          Contact Support
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: "#6B7280" }}>
            Choose how you'd like to contact us
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={() => setOpenDialog(false)}
            sx={{
              color: "#6B7280",
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEmail}
            variant="outlined"
            sx={{
              borderColor: "#006D77",
              color: "#006D77",
              textTransform: "none",
              "&:hover": {
                borderColor: "#005A63",
                bgcolor: "#F0F9FA",
              },
            }}
          >
            Email
          </Button>
          {/* <Button
            onClick={handleCall}
            variant="contained"
            sx={{
              bgcolor: "#006D77",
              textTransform: "none",
              "&:hover": {
                bgcolor: "#005A63",
              },
            }}
          >
            Call
          </Button> */}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MedicineOrderSuccessScreen;